import { useCallback } from "react";

import { postHTML } from "@/lib/aws-amplify/storage";
import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HotelI18nArticleUpdate_DesignPage_Mutation } from "./mutation";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const useHotelI18nArticleUpdateMutation = ({ hotelID, langCode }: Props) => {
	const { mutationFunc } = useCustomMutation(HotelI18nArticleUpdate_DesignPage_Mutation);

	const onUpdate = useCallback(
		async ({ articleHTML }: { articleHTML: string }) => {
			const { s3Object } = await postHTML({
				html: articleHTML,
				lang: langCode,
				hotelID,
				resourceID: hotelID,
			});

			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						article: s3Object,
						lang: langCode,
					},
				},
			});
		},
		[hotelID, langCode, mutationFunc],
	);

	return {
		onUpdate,
	};
};
